import React, { createContext, useReducer } from 'react'

export const SET_TEST_ZONE_DATA = 'SET_TEST_ZONE_DATA'
export const UPDATE_CHANGE_TEST_ZONE_DATA = 'UPDATE_CHANGE_TEST_ZONE_DATA'
export const SET_SELECTED_TEST_ZONE_DATA = 'SET_SELECTED_TEST_ZONE_DATA'
export const SHOW_TEST_ZONE_FORM = 'SHOW_TEST_ZONE_FORM'
export const SET_PLANT_DATA = 'SET_PLANT_DATA'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_TEST_ZONE_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_TEST_ZONE_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData, showFormPopup: false }
    }
    case SET_SELECTED_TEST_ZONE_DATA: {
      return { ...data, selectedObject: payload.data, showFormPopup: true }
    }
    case SHOW_TEST_ZONE_FORM: {
      return {
        ...data,
        showFormPopup: payload.showFormPopup,
        selectedObject: payload.data,
      }
    }
    case SET_PLANT_DATA: {
      return { ...data, plants: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  showFormPopup: false,
  plants: [],
}

const TestZoneStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <TestZoneContext.Provider value={[state, dispatch]}>
      {children}
    </TestZoneContext.Provider>
  )
}

export const TestZoneContext = createContext(initialState)
export default TestZoneStore
